import Controller from '@ember/controller';
import { action, get, set } from '@ember/object';
import { alias } from '@ember/object/computed';
import { service } from '@ember/service';
import { task } from 'ember-concurrency';

export default Controller.extend({
  router: service(),
  store: service(),
  fundsService: service(),

  alertUnitOptions: [
    {
      label: 'Days',
      val: 'days',
    },
    {
      label: 'Weeks',
      val: 'weeks',
    },
    {
      label: 'Months',
      val: 'months',
    },
  ],

  isNew: alias('model.record.isNew'),

  save: task(function* () {
    yield this.fundsService.confirmValidFundToken();
    let changeset = get(this, 'model.changeset');
    yield changeset.validate();
    if (get(changeset, 'isValid')) {
      try {
        yield changeset.save();
        this.router.transitionTo('funds.fund.contacts.contact');
      } catch (e) {
        if (get(this, 'model.record.errors.length') > 0) {
          get(this, 'model.record.errors').forEach(({ attribute, message }) => {
            changeset.pushErrors(attribute, message);
          });
        } else {
          throw e;
        }
      }
    }
  }).drop(),

  handleEnableAlertChanged: action(function (enabled) {
    if (enabled) {
      set(this, 'model.changeset.alertNumber', 2);
      set(this, 'model.changeset.alertUnit', 'weeks');
    }
  }),
});
